import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-lsa-dark text-white pt-8 pb-12 px-5 flex flex-col items-center text-center" data-id="element-108">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-xl w-full flex flex-col items-center" data-id="element-109">
        <div className="inline-block bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-xs font-semibold mb-6 tracking-wide" data-id="element-110">
          🇦🇷 Sistema Completo para Profesores de LSA · Edición 2026
        </div>

        <h1 className="text-[32px] sm:text-[40px] leading-[1.1] font-extrabold mb-6 tracking-tight uppercase" data-id="element-111">
          Tus clases de LSA{' '}
          <span className="relative inline-block text-lsa-cyan" data-id="element-112">
            resueltas
            <span className="absolute left-0 -bottom-1 h-1 w-full rounded-full bg-lsa-cyan/60" data-id="element-113" />
          </span>
          . Para siempre.
        </h1>

        <motion.img src="https://cdn.magicpatterns.com/uploads/sfY8nMytZyqtcAyNMkrfLd/Untitled_design_(1).png" alt="Sistema LSA Fácil — libro completo con material de práctica, tarjetas y planillas de seguimiento" className="w-full max-w-sm mx-auto mb-6 drop-shadow-2xl select-none pointer-events-none" style={{
        animation: 'lsa-float 4s ease-in-out infinite'
      }} initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-114" />

        <p className="text-white/80 text-[15px] sm:text-base leading-relaxed mb-8 max-w-md" data-id="element-115">
          El sistema que necesitaban los profesores de Lengua de Señas Argentina
          para organizar, planificar y dictar clases sin perder horas armando
          material desde cero.
        </p>

        <div className="w-full flex flex-col gap-3 mb-6" data-id="element-116">
          <button onClick={scrollToPricing} className="w-full bg-lsa-cyan hover:brightness-110 text-lsa-deep h-[56px] rounded-xl font-bold text-[17px] transition-all shadow-lg shadow-lsa-cyan/30 flex items-center justify-center gap-2" data-id="element-117">
            <span className="text-xl" data-id="element-118">🤟</span> Quiero el Sistema para
            Profesores
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 text-xs sm:text-sm text-white/70 font-medium" data-id="element-119">
          <span className="flex items-center gap-1" data-id="element-120">⭐ 4.9/5 calificación</span>
          <span className="flex items-center gap-1" data-id="element-121">👥 +1.200 profesores</span>
          <span className="flex items-center gap-1" data-id="element-122">📦 7 Tomos + 6 Bonos</span>
          <span className="flex items-center gap-1" data-id="element-123">🔒 Garantía 7 días</span>
          <span className="flex items-center gap-1" data-id="element-124">⚡ Acceso inmediato</span>
        </div>
      </motion.div>
    </section>;
}